"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var type_guards_1 = require("../../type-guards");
var helpers_1 = require("../../helpers");
function MessageFileImage(_a) {
    var file = _a.file;
    var imageUrl = (0, type_guards_1.isDatabaseFile)(file) ? file.url : URL.createObjectURL(file);
    var fileName = (0, type_guards_1.isDatabaseFile)(file)
        ? (0, helpers_1.getFileNameFromPath)(file.key)
        : file.name;
    var _b = (0, react_1.useState)(false), isLoaded = _b[0], setIsLoaded = _b[1];
    var imgRef = (0, react_1.useRef)(null);
    var loaderRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (isLoaded) {
            loaderRef.current && (loaderRef.current.style.display = "none");
            imgRef.current && (imgRef.current.style.height = "auto");
        }
    }, [isLoaded]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isLoaded && (react_1.default.createElement("div", { className: "loader p-2 grid place-center" },
            react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18", ref: loaderRef },
                react_1.default.createElement("use", { href: "#loader" })))),
        (0, type_guards_1.isDatabaseFile)(file) && (react_1.default.createElement("button", { className: "message-file image-file grid place-center".concat(isLoaded ? " loaded" : "") },
            react_1.default.createElement("a", { className: "img-popup", href: imageUrl },
                react_1.default.createElement("img", { loading: "lazy", src: imageUrl, alt: fileName, title: fileName, onLoad: function () { return setIsLoaded(true); }, ref: imgRef, style: { height: "0" } }))))));
}
exports.default = MessageFileImage;
